import { jwtDecode } from 'jwt-decode'

export default () => {
    const accessToken = useUserSession().session.value?.tokens?.accessToken

    if (!accessToken) {
        return false
    }

    const decodedToken = jwtDecode(accessToken)

    if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
        return false
    }

    return true
}
